// EU-762 (QA 01/10) — PRIMEIRO import de propósito: o gate de offline precisa
// registrar o `popstate` dele ANTES do `createBrowserHistory` abaixo. No alvo
// (`window`) os listeners disparam na ordem de registro, ignorando a flag de
// captura; registrado depois, o gate não consegue engolir o popstate do próprio
// fechamento e o router aciona o `useBlocker` da tela ("Quer sair sem terminar?").
import '@/lib/offline/start-before-router';
import { createRouter } from '@tanstack/react-router';
import { queryClient } from '@/lib/query-client';
import { routeTree } from '@/routeTree.gen';
import { NotFoundScreen, RouterErrorScreen } from '@/shared/error-screens';

export const router = createRouter({
  routeTree,
  context: { query: queryClient },
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
  // EU-636 (UNI-016) — 404 do DS (substitui o `Navigate to "/"` silencioso).
  defaultNotFoundComponent: NotFoundScreen,
  // EU-636 (UNI-017/018) — sem-conexão (offline) / erro de servidor (500-503).
  defaultErrorComponent: RouterErrorScreen,
});

declare module '@tanstack/react-router' {
  interface HistoryState {
    /** Blob URL or remote URL for edit-photo preview step */
    previewSrc?: string;
  }
  interface Register {
    router: typeof router;
  }
  interface StaticDataRouteOption {
    /** Page subtitle rendered by parent layout-routes (e.g. PersonalDataLayout). */
    subtitle?: string;
  }
}
